module.exports = __webpack_public_path__ + "static/bkg-3ce15b6754f0a58e100f519eb57fa3ad.jpg";